<template>
  <v-dialog
    :value="value"
    persistent
    width="500"
    @input="$emit('input', $event)"
  >
    <v-card style="padding-bottom: 8px">
      <v-toolbar color="#1b2643" dark>
        {{ $t('editPackage.deleteDialogHeader') }}
      </v-toolbar>
      <v-card-text>
        <div class="text-center" style="padding-top: 20px; text-align: center">
          <p style="white-space: pre-wrap">
            {{ $t('editPackage.deleteConfirmationMessage') }}
          </p>
        </div>
      </v-card-text>
      <v-card-actions class="justify-end pt-4 pb-4">
        <v-btn text @click="$emit('cancel')">
          <v-icon left>mdi-arrow-u-left-top</v-icon>
          {{ $t('editPackage.cancel') }}
        </v-btn>
        <v-btn :loading="isDeleting" color="error" @click="$emit('confirm')">
          <v-icon left>mdi-trash-can-outline</v-icon>
          {{ $t('editPackage.delete') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <snack-bar
      :snackbarAction="deleteErrorSnackbar"
      :snackbarText="deleteErrorSnackbarText"
      snackbarColor="pink"
      @closeSnackbar="$emit('closeSnackbar')"
    />
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import SnackBar from "@/components/Dashboard/PageViewItems/SnackbarComponent.vue";
export default defineComponent({
  name: "DeleteConfirmationDialog",
  components: {
    SnackBar,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    isDeleting: {
      type: Boolean,
      default: false,
    },
    deleteErrorSnackbar: {
      type: Boolean,
      default: false,
    },
    deleteErrorSnackbarText: {
      type: String,
      default: "",
    },
  },
});
</script>
